module.exports = __webpack_public_path__ + "img/swift-sport-rojo-vanadio.13c5b69f.png";